import { getStateFromZipcode } from '../zipcode-utils';

const validatePage = () => {
  if ((window.digitalData.page)
    && (window.digitalData.page.pageInfo)
    && window.digitalData.page.pageInfo.pageName
      && window.digitalData.page.pageInfo.pageType) {
    return true;
  }
  return false;
};

const validateUser = () => {
  if ((window.digitalData.user)
    && (window.digitalData.user.profile)
      && window.digitalData.user.profile.authenticationStatus) {
    return true;
  }
  return false;
};

const tryInitialize = () => {
  if (validatePage() && validateUser()) {
    window.ddoInit(window.digitalData);
  }
};

export const setPage = (page) => {
  window.digitalData.page = page;
  tryInitialize();
};

export const setPageInfo = (pageName, pageType) => {
  const pageInfo = { pageName, pageType };

  if (!window.digitalData) {
    window.digitalData = {};
  }

  if (!window.digitalData.page) {
    window.digitalData.page = {};
  }

  window.digitalData.page.pageInfo = pageInfo;
  tryInitialize();
};

export const setSiteInfo = (siteInfo) => {
  if (!window.digitalData.site) {
    window.digitalData.site = {};
  }
  window.digitalData.site = siteInfo;
};

export const setAdditionalPageInfo = (propertyName, additionalData) => {
  if (!window.digitalData) {
    window.digitalData = {};
  }

  if (!window.digitalData.page) {
    window.digitalData.page = {};
  }

  switch (propertyName) {
  case 'category':
    window.digitalData.page.category = { ...additionalData };
    break;
  case 'eventInfo':
    window.digitalData.page.inventInfo = { ...additionalData };
    break;
  case 'pageInfo':
    window.digitalData.page.pageInfo = { ...additionalData };
    break;
  case 'item': {
    if (!window.digitalData.product) {
      window.digitalData.product = [];
    }

    const existingProduct = window.digitalData.product[0];
    const newProductName = additionalData?.productInfo?.productName;

    if (
      !existingProduct ||
    existingProduct?.productInfo?.productName !== newProductName
    ) {
      window.digitalData.product = [additionalData];
    }

    break;
  }
  default:
  }
};

export const setAuthenticationStatus = (authenticationStatus) => {
  window.digitalData.user = window.digitalData.user || {};
  window.digitalData.user.profile = window.digitalData.user.profile || {};

  window.digitalData.user.profile.authenticationStatus = authenticationStatus;
  tryInitialize();
};

export const setProductInfo = ({ omsId, productName, brand }) => {
  window.digitalData.product = window.digitalData.product || [];
  const productInfo = {
    sku: `${omsId}`, productName, manufacturer: `${brand}`, productType: 'merchandise',
  };

  window.digitalData.product.push(productInfo);
};

export const setUserLocalization = (storeInfo) => {
  if (typeof window !== 'undefined') {
    if (typeof window?.digitalData?.user !== 'undefined') {
      window.digitalData.user.localization = {};
      const zipDetails = window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getDeliveryZipcodeDetails();
      const locationInfo = {
        gpsPermission: 'granted',
        inStoreNumber: 'not in store',
        method: 'default',
        storeState: getStateFromZipcode(storeInfo?.storeZip) || '',
        storeZip: storeInfo?.storeZip,
        storeNumber: `${storeInfo?.storeId}`,
        storeName: storeInfo?.storeName,
        userZip: zipDetails?.zipcode || ''
      };

      window.digitalData.user.localization = locationInfo;
      tryInitialize();
    }
  }
};

export const setPageErrorInfo = (errorObject) => {
  if (typeof window !== 'undefined') {
    if (typeof window?.digitalData !== 'undefined') {
      if (!window.digitalData.page) {
        window.digitalData.page = {};
      }
      window.digitalData.page.error = window.digitalData.page.error || [];
      window.digitalData.page.error.push(errorObject);
    }
  }
};
